var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.meta.header !== false)?_c('respondeco-header'):_vm._e(),_c('http-error',{staticClass:"g-mb-100",attrs:{"errorStatus":404}}),(_vm.$route.meta.footer !== false)?_c('respondeco-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }